import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import config from '@config'
import { mobileCSS } from '@measures/responsive'
import FreeRatioImage from '@components/FreeRatioImage'

import { StyledFmTOnboardingContainerProps } from './FmTOnboardingContainer'

const {
  publication: { publication },
} = config

interface QRCodeProps {
  isInDrawer: StyledFmTOnboardingContainerProps['isInDrawer']
}

const IMAGE_ROMANDIE = {
  src: '/incoming/21351288-v0-qrcode-blick-app-fr.png',
  alt: 'appstore code',
  width: 1000,
  height: 505,
  crops: {},
} as const

const expectedDimensionsRomandie = { width: 158, height: 80 } as const

const constraintsRomandie = {
  desktop: expectedDimensionsRomandie,
  tablet: expectedDimensionsRomandie,
  mobile: expectedDimensionsRomandie,
  mobileSmall: expectedDimensionsRomandie,
} as const

const IMAGE_BLICK = {
  src: '/incoming/21351290-v0-qrcode-blick-app-de.png',
  alt: 'appstore code',
  width: 1000,
  height: 475,
  crops: {},
} as const

const expectedDimensionsBlick = { width: 168, height: 80 } as const

const constraintsBlick = {
  desktop: expectedDimensionsBlick,
  tablet: expectedDimensionsBlick,
  mobile: expectedDimensionsBlick,
  mobileSmall: expectedDimensionsBlick,
} as const

const StyledQRCodeRomandie = styled(FreeRatioImage)<QRCodeProps>`
  ${({ isInDrawer }) => css`
    align-self: center;
    grid-area: ${isInDrawer ? '2 / 2 / 3 / 4' : '1 / 2 / 3 / 3'};
    justify-self: end;
    ${mobileCSS(css`
      display: none;
    `)}
  `}
`

const IMAGE = publication === 'romandie' ? IMAGE_ROMANDIE : IMAGE_BLICK

const constraints =
  publication === 'romandie' ? constraintsRomandie : constraintsBlick

const QRCode: FunctionComponent<QRCodeProps> = ({ isInDrawer }) => (
  <StyledQRCodeRomandie
    isInDrawer={isInDrawer}
    src={IMAGE.src}
    alt={IMAGE.alt}
    crops={IMAGE.crops}
    originalDimensions={{
      width: IMAGE.width,
      height: IMAGE.height,
    }}
    constraints={constraints}
  />
)

export default QRCode
